import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import axios from "axios";
import {
    Box,
    Container,
    Typography,
    Card,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Pagination,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    InputAdornment,
    IconButton,
    Tooltip
} from "@mui/material";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import SendIcon from "@mui/icons-material/Send";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import swal from "sweetalert";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

function ThongBao() {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalMessages, setTotalMessages] = useState(0);

    // Filters
    const [searchInput, setSearchInput] = useState("");
    const [searchedText, setSearchedText] = useState("");
    const [filterType, setFilterType] = useState("");

    // Modal Send State
    const [openSendModal, setOpenSendModal] = useState(false);
    const [msgType, setMsgType] = useState("all"); // "all" | "single"
    const [recipientUsername, setRecipientUsername] = useState("");
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [submitting, setSubmitting] = useState(false);

    // Modal Detail State
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [selectedMsg, setSelectedMsg] = useState(null);

    const limit = 15;

    const fetchMessages = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/notification/system-messages?page=${page}&limit=${limit}&search=${searchedText}&type=${filterType}`)
            .then((res) => {
                if (res.data.success) {
                    setMessages(res.data.data || []);
                    setTotalPages(res.data.totalPages || 1);
                    setTotalMessages(res.data.total || 0);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Fetch messages error:", err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchMessages();
    }, [page, searchedText, filterType]);

    const handleSearch = () => {
        setSearchedText(searchInput);
        setPage(1);
    };

    const handleReset = () => {
        setSearchInput("");
        setSearchedText("");
        setFilterType("");
        setPage(1);
    };

    const handleOpenSend = () => {
        setMsgType("all");
        setRecipientUsername("");
        setTitle("");
        setContent("");
        setOpenSendModal(true);
    };

    const handleCloseSend = () => {
        setOpenSendModal(false);
    };

    const handleSendMessage = () => {
        if (!title.trim() || !content.trim()) {
            swal("Lỗi!", "Vui lòng nhập đầy đủ tiêu đề và nội dung tin nhắn!", "error");
            return;
        }
        if (msgType === "single" && !recipientUsername.trim()) {
            swal("Lỗi!", "Vui lòng nhập tên tài khoản người nhận!", "error");
            return;
        }

        setSubmitting(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/notification/send-message`, {
                title: title.trim(),
                content: content.trim(),
                type: msgType,
                recipientUsername: recipientUsername.trim()
            })
            .then((res) => {
                setSubmitting(false);
                if (res.data.success) {
                    swal("Thành công!", res.data.message || "Gửi tin nhắn thành công!", "success");
                    setOpenSendModal(false);
                    fetchMessages();
                } else {
                    swal("Lỗi!", res.data.message || "Gửi tin nhắn thất bại!", "error");
                }
            })
            .catch((err) => {
                setSubmitting(false);
                const msg = err?.response?.data?.message || "Có lỗi xảy ra khi gửi tin nhắn!";
                swal("Lỗi!", msg, "error");
            });
    };

    const handleDeleteMessage = (id) => {
        swal({
            title: "Xác nhận xóa?",
            text: "Bạn có chắc chắn muốn xóa tin nhắn này khỏi nhật ký hệ thống?",
            icon: "warning",
            buttons: ["Hủy", "Xóa"],
            dangerMode: true
        }).then((willDelete) => {
            if (willDelete) {
                axios
                    .delete(`${process.env.REACT_APP_API_URL}/notification/system-messages/${id}`)
                    .then((res) => {
                        if (res.data.success) {
                            swal("Thành công!", "Đã xóa tin nhắn!", "success");
                            fetchMessages();
                        } else {
                            swal("Lỗi!", res.data.message || "Xóa thất bại!", "error");
                        }
                    })
                    .catch(() => {
                        swal("Lỗi!", "Có lỗi xảy ra khi xóa tin nhắn!", "error");
                    });
            }
        });
    };

    const handleViewDetail = (msg) => {
        setSelectedMsg(msg);
        setOpenDetailModal(true);
    };

    const formatDate = (val) => {
        if (!val) return "-";
        const d = new Date(val);
        const day = ("0" + d.getDate()).slice(-2);
        const month = ("0" + (d.getMonth() + 1)).slice(-2);
        const year = d.getFullYear();
        const hours = ("0" + d.getHours()).slice(-2);
        const minutes = ("0" + d.getMinutes()).slice(-2);
        const seconds = ("0" + d.getSeconds()).slice(-2);
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 3 }}>
                    {loading && (
                        <div className="loading" style={{ maxWidth: "100%", zIndex: 9999 }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        {/* Header */}
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}>
                            <Typography variant="h4" sx={{ fontWeight: 700, display: "flex", alignItems: "center", gap: 1.5, color: "#0f172a" }}>
                                <MarkEmailUnreadIcon sx={{ fontSize: 34, color: "#2563eb" }} /> Quản Lý Tin Nhắn Hộp Thư
                            </Typography>
                            <Button
                                variant="contained"
                                startIcon={<SendIcon />}
                                onClick={handleOpenSend}
                                sx={{
                                    height: "42px",
                                    textTransform: "none",
                                    fontWeight: 700,
                                    fontSize: "15px",
                                    backgroundColor: "#2563eb",
                                    boxShadow: "0 4px 6px -1px rgb(37 99 235 / 0.2)",
                                    "&:hover": { backgroundColor: "#1d4ed8" }
                                }}
                            >
                                Gửi tin nhắn mới
                            </Button>
                        </Box>

                        {/* Filter Card */}
                        <Card sx={{ p: 2.5, mb: 3, borderRadius: 2, boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)", backgroundColor: "#ffffff" }}>
                            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center" }}>
                                <TextField
                                    size="small"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    placeholder="Tìm kiếm tiêu đề, người nhận, nội dung..."
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon sx={{ color: "#94a3b8", fontSize: 20 }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{ minWidth: 280, "& .MuiInputBase-root": { height: "40px" } }}
                                />

                                <FormControl size="small" sx={{ minWidth: 180 }}>
                                    <TextField
                                        select
                                        size="small"
                                        value={filterType}
                                        onChange={(e) => setFilterType(e.target.value)}
                                        SelectProps={{ native: true }}
                                        sx={{ "& .MuiInputBase-root": { height: "40px" } }}
                                    >
                                        <option value="">Tất cả loại tin nhắn</option>
                                        <option value="all">Toàn hệ thống (All)</option>
                                        <option value="single">Cá nhân (Single User)</option>
                                    </TextField>
                                </FormControl>

                                <Box sx={{ display: "flex", gap: 1.5, ml: "auto" }}>
                                    <Button
                                        variant="contained"
                                        startIcon={<SearchIcon />}
                                        onClick={handleSearch}
                                        sx={{ height: "40px", textTransform: "none", fontWeight: 600, backgroundColor: "#2563eb" }}
                                    >
                                        Tìm kiếm
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        startIcon={<RestartAltIcon />}
                                        onClick={handleReset}
                                        sx={{ height: "40px", textTransform: "none", fontWeight: 600, borderColor: "#cbd5e1", color: "#475569" }}
                                    >
                                        Cài lại
                                    </Button>
                                </Box>
                            </Box>
                        </Card>

                        {/* Table Card */}
                        <Card sx={{ borderRadius: 2, boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)", overflowX: "auto" }}>
                            <Table sx={{ minWidth: 750 }}>
                                <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 700, color: "#334155", py: 2 }}>#</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "#334155", py: 2 }}>Loại tin nhắn</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "#334155", py: 2 }}>Người nhận</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "#334155", py: 2 }}>Tiêu đề</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "#334155", py: 2 }}>Nội dung xem trước</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "#334155", py: 2 }}>Thời gian gửi</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: "#334155", py: 2, textAlign: "center" }}>Thao tác</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {messages.length > 0 ? (
                                        messages.map((item, idx) => (
                                            <TableRow key={item._id} sx={{ "&:hover": { backgroundColor: "#f8fafc" } }}>
                                                <TableCell sx={{ py: 1.8, color: "#64748b" }}>
                                                    {(page - 1) * limit + idx + 1}
                                                </TableCell>
                                                <TableCell sx={{ py: 1.8 }}>
                                                    {item.type === "single" ? (
                                                        <Chip
                                                            label="Cá nhân"
                                                            size="small"
                                                            sx={{ backgroundColor: "#f0f9ff", color: "#0284c7", fontWeight: 700, border: "1px solid #bae6fd" }}
                                                        />
                                                    ) : (
                                                        <Chip
                                                            label="Tất cả người chơi"
                                                            size="small"
                                                            sx={{ backgroundColor: "#ecfdf5", color: "#047857", fontWeight: 700, border: "1px solid #a7f3d0" }}
                                                        />
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ py: 1.8, fontWeight: 700, color: item.type === "single" ? "#2563eb" : "#059669" }}>
                                                    {item.type === "single" ? (item.recipientUsername || item.recipient?.username || "N/A") : "Toàn bộ hệ thống"}
                                                </TableCell>
                                                <TableCell sx={{ py: 1.8, fontWeight: 600, color: "#0f172a", maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                    {item.title}
                                                </TableCell>
                                                <TableCell sx={{ py: 1.8, color: "#475569", maxWidth: 280, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                    {item.content}
                                                </TableCell>
                                                <TableCell sx={{ py: 1.8, color: "#64748b", fontWeight: 500 }}>
                                                    {formatDate(item.createdAt)}
                                                </TableCell>
                                                <TableCell sx={{ py: 1.8, textAlign: "center" }}>
                                                    <Tooltip title="Xem chi tiết">
                                                        <IconButton size="small" color="primary" onClick={() => handleViewDetail(item)}>
                                                            <VisibilityIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Xóa tin nhắn">
                                                        <IconButton size="small" color="error" onClick={() => handleDeleteMessage(item._id)}>
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center" sx={{ py: 6, color: "#94a3b8", fontSize: "15px" }}>
                                                Chưa có tin nhắn nào trong lịch sử
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>

                        {/* Pagination */}
                        {messages.length > 0 && (
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                                <Pagination
                                    color="primary"
                                    page={page}
                                    count={totalPages}
                                    shape="rounded"
                                    onChange={(e, p) => setPage(p)}
                                />
                            </Box>
                        )}
                    </Container>

                    {/* Dialog Soạn Tin Nhắn Mới */}
                    <Dialog open={openSendModal} onClose={handleCloseSend} maxWidth="sm" fullWidth>
                        <DialogTitle sx={{ fontWeight: 700, fontSize: "18px", color: "#0f172a" }}>
                            Gửi Tin Nhắn Mới Hộp Thư
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, pt: 1 }}>
                                <FormControl component="fieldset">
                                    <FormLabel sx={{ fontWeight: 700, color: "#334155", mb: 0.5 }}>Đối tượng nhận tin:</FormLabel>
                                    <RadioGroup
                                        row
                                        value={msgType}
                                        onChange={(e) => setMsgType(e.target.value)}
                                    >
                                        <FormControlLabel value="all" control={<Radio />} label="Tất cả người chơi (All Users)" />
                                        <FormControlLabel value="single" control={<Radio />} label="Gửi cá nhân (1 User)" />
                                    </RadioGroup>
                                </FormControl>

                                {msgType === "single" && (
                                    <TextField
                                        label="Tên tài khoản người nhận (Username)"
                                        size="small"
                                        fullWidth
                                        value={recipientUsername}
                                        onChange={(e) => setRecipientUsername(e.target.value)}
                                        placeholder="Ví dụ: player123"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <PersonSearchIcon sx={{ color: "#2563eb" }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}

                                <TextField
                                    label="Tiêu đề tin nhắn"
                                    size="small"
                                    fullWidth
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Nhập tiêu đề tin nhắn..."
                                />

                                <TextField
                                    label="Nội dung tin nhắn"
                                    multiline
                                    rows={5}
                                    fullWidth
                                    value={content}
                                    onChange={(e) => setContent(e.target.value)}
                                    placeholder="Nhập nội dung chi tiết tin nhắn..."
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ px: 3, py: 2 }}>
                            <Button onClick={handleCloseSend} sx={{ color: "#64748b", textTransform: "none", fontWeight: 600 }}>
                                Hủy bỏ
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<SendIcon />}
                                disabled={submitting}
                                onClick={handleSendMessage}
                                sx={{ backgroundColor: "#2563eb", textTransform: "none", fontWeight: 700, px: 3 }}
                            >
                                {submitting ? "Đang gửi..." : "Gửi tin nhắn"}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* Dialog Xem Chi Tiết Tin Nhắn */}
                    <Dialog open={openDetailModal} onClose={() => setOpenDetailModal(false)} maxWidth="sm" fullWidth>
                        <DialogTitle sx={{ fontWeight: 700, fontSize: "18px", color: "#0f172a" }}>
                            Chi Tiết Tin Nhắn
                        </DialogTitle>
                        <DialogContent dividers>
                            {selectedMsg && (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                    <Box>
                                        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>ĐỐI TƯỢNG NHẬN:</Typography>
                                        <Typography variant="body1" sx={{ fontWeight: 700, color: selectedMsg.type === "single" ? "#2563eb" : "#059669" }}>
                                            {selectedMsg.type === "single" ? `Cá nhân: ${selectedMsg.recipientUsername || selectedMsg.recipient?.username || "N/A"}` : "Toàn bộ người chơi trên hệ thống"}
                                        </Typography>
                                    </Box>

                                    <Box>
                                        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>TIÊU ĐỀ:</Typography>
                                        <Typography variant="h6" sx={{ fontWeight: 700, color: "#0f172a" }}>
                                            {selectedMsg.title}
                                        </Typography>
                                    </Box>

                                    <Box>
                                        <Typography variant="caption" sx={{ color: "#64748b", fontWeight: 600 }}>NỘI DUNG:</Typography>
                                        <Box sx={{ p: 2, backgroundColor: "#f8fafc", borderRadius: 1.5, border: "1px solid #e2e8f0", mt: 0.5 }}>
                                            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", color: "#334155", lineHeight: 1.6 }}>
                                                {selectedMsg.content}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ display: "flex", justifyContent: "space-between", color: "#64748b", fontSize: "13px", pt: 1 }}>
                                        <span>Người gửi: {selectedMsg.sender || "Admin"}</span>
                                        <span>Thời gian: {formatDate(selectedMsg.createdAt)}</span>
                                    </Box>
                                </Box>
                            )}
                        </DialogContent>
                        <DialogActions sx={{ px: 3, py: 1.5 }}>
                            <Button onClick={() => setOpenDetailModal(false)} variant="contained" sx={{ textTransform: "none", backgroundColor: "#2563eb" }}>
                                Đóng
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default ThongBao;
